module.exports = __webpack_public_path__ + "img/card-back-image.9396c466.png";